/* eslint-disable eqeqeq */
import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import { bind, isNil, isArray, Dropdown, FieldInfo, ControlTypes } from 'vdlib';
import { PartyTypes } from 'vdlib';

import { SearchOutlined } from '@ant-design/icons';

import WidgetCounter from './WidgetCounter';
import Overview from './Overview';
import UpdateEstimationsResultsModal from './UpdateEstimationsResultsModal';
import LookupsHelper from 'lib/LookupsHelper';

import _ from 'lodash';

import Tabs from 'antd/lib/tabs';
import Tooltip from 'antd/lib/tooltip';
import Spin from 'antd/lib/spin';
import Popconfirm from 'antd/lib/popconfirm';
import Button from 'antd/lib/button';
import Table from 'antd/lib/table';

import { Input, Select, DatePicker, Badge, Col } from 'antd';

import moment from 'moment';
import 'moment/locale/el';

import '../../index.css';

import { createEstimationColumns } from './columnDefs';

const { RangePicker } = DatePicker;
const dateFormat = 'DD-MM-YYYY';
const { Option } = Select;

class GTEstimateDashboard extends React.Component {
  constructor(props) {
    super(props);

    bind(this, [
      'reload',
      'populate',
      'tabChange',
      'openUpdateEstimationsModal',
      'updateEstimations',
      'rerunEstimations',
      'deleteEstimation',
      'runEstimation',
      'deleteSelectedEstimations',
      'runSelectedEstimations',
      'fetchDashboardData',
      'runFailedEstimations',
      'runPendingEstimations',
      'resetProcessingEstimations',
      'onSubmit',
      'onSelectPeriod',
    ]);

    this.state = {
      loading: false,
      reload: false,
      selectedRowsEstimationIDs: [],
      selectedRowsEstimations: [],
      selectedRowsTotal: 0,
      showUpdateEstimationsModal: false,
      insuranceID:
        LookupsHelper.getDescription(props.partyTypes, props.user.PartyType) ===
        PartyTypes.Admin_Insurance
          ? props.userParty.InsuranceID
          : null,
      dateFrom: moment(moment(), dateFormat).toDate(),
      dateTo: moment(moment(), dateFormat).toDate(),
      insurancesData: [],
      error: false,
      showResults: false,
      selectedRowKeys: [],
      currentEstimationsData: [],
      newEstimationsData: [],
      pendingEstimationsData: [],
      failedEstimationsData: [],
      partEstimationsData: [],
      processingEstimationsData: [],
      smallDamageEstimationsData: [],
      filteredData: [],
      filters: [],
      selectedTabKey: '',
      partyType: LookupsHelper.getDescription(
        props.partyTypes,
        props.user.PartyType
      ),
      isAdminInsurance:
        LookupsHelper.getDescription(props.partyTypes, props.user.PartyType) ===
        PartyTypes.Admin_Insurance,
    };

    this.formContext = {
      updateForm: (name, value) => {
        if (name == 'insuranceID') this.setState({ insuranceID: value });
      },
    };

    moment.locale('gr');
    this.populate();
  }

  componentDidMount() {
    this.fetchDashboardData(true);
  }

  componentDidUnMount() {
    this.fetchDashboardData(false);
  }

  estimationsDatesToMoment = data => {
    return data.map(item =>
      Object.assign({}, item, {
        DateCreation: moment(item.DateCreation).format('DD/MM/YYYY hh:mm:ss'),
        DateModification: moment(item.DateModification).format(
          'DD/MM/YYYY hh:mm:ss'
        ),
        DateLastProcessing: moment(item.DateLastProcessing).format(
          'DD/MM/YYYY hh:mm:ss'
        ),
      })
    );
  };

  componentDidUpdate(prevProps) {
    const { dashboardData } = this.props;

    const { selectedTabKey } = this.state;
    if (
      !this.props.hasError &&
      this.props.dashboardData &&
      prevProps.dashboardData != this.props.dashboardData
    ) {
      let grouped = _.chain(this.props.dashboardData.GTEstimations)
        .groupBy('InsuranceID')
        .map((value, key) => ({
          Insurance: this.props.insurances.find(x => x.ID == key).Description,
          Estimations: value,
        }))
        .value();

      this.setState({
        loading: false,
        insurancesData: grouped,
        currentEstimationsData: this.chooseDashboardData(selectedTabKey)
          ? this.estimationsDatesToMoment(
              this.chooseDashboardData(selectedTabKey)
            )
          : [],
        newEstimationsData: dashboardData.GTEstimations
          ? this.estimationsDatesToMoment(dashboardData.GTEstimations)
          : [],
        pendingEstimationsData: dashboardData.PendingEstimations
          ? this.estimationsDatesToMoment(dashboardData.PendingEstimations)
          : [],
        failedEstimationsData: dashboardData.FailedEstimations
          ? this.estimationsDatesToMoment(dashboardData.FailedEstimations)
          : [],
        processingEstimationsData: dashboardData.ProcessingEstimations
          ? this.estimationsDatesToMoment(dashboardData.ProcessingEstimations)
          : [],
        smallDamageEstimationsData: dashboardData.SmallDamageEstimations
          ? this.estimationsDatesToMoment(dashboardData.SmallDamageEstimations)
          : [],
        partEstimationsData: dashboardData.PartEstimations
          ? this.estimationsDatesToMoment(dashboardData.PartEstimations)
          : [],
      });

      this.filterData(
        this.chooseDashboardData(selectedTabKey)
          ? this.estimationsDatesToMoment(
              this.chooseDashboardData(selectedTabKey)
            )
          : []
      );
    }

    if (
      !this.props.hasError &&
      this.props.updateData &&
      prevProps.updateData != this.props.updateData
    ) {
      this.setState({
        error: false,
      });
      this.fetchDashboardData(true);
    }

    if (
      !this.props.hasError &&
      this.props.rerunData &&
      prevProps.rerunData != this.props.rerunData
    ) {
      this.fetchDashboardData(false);
    }

    if (
      !this.props.hasError &&
      this.props.resetProcessing &&
      prevProps.resetProcessing != this.props.resetProcessing
    ) {
      this.fetchDashboardData(false);
    }

    if (
      !this.props.hasError &&
      this.props.deleteData &&
      prevProps.deleteData != this.props.deleteData
    ) {
      this.fetchDashboardData(false);
    }

    if (prevProps.loading != this.props.loading) {
      this.setState({ loading: this.props.loading });
    }

    if (this.props.hasError && this.props.updateDataError) {
      this.setState({
        error: this.props.updateDataError,
      });
    }
  }

  onSelectPeriod(date, dateString) {
    if (dateString && dateString.length === 2) {
      this.setState({
        dateFrom: moment.utc(dateString[0], dateFormat).toDate(),
        dateTo: moment.utc(dateString[1], dateFormat).toDate(),
      });
    }
  }

  clearSelectedEstimation = () => {
    this.setState({
      selectedRowsEstimationIDs: [],
      selectedRowsEstimations: [],
      selectedRowsTotal: 0,
      selectedRowKeys: [],
    });
  };

  fetchDashboardData(showResults) {
    if (!this.state.isAdminInsurance) this.props.fetchData();
    else this.props.fetchData(this.props.userParty.InsuranceID);

    this.setState({
      loading: true,
      selectedRowsEstimationIDs: [],
      selectedRowsEstimations: [],
      selectedRowsTotal: 0,
      selectedRowKeys: [],
      showResults: showResults,
    });
  }

  populate(props) {
    if (isNil(props)) props = this.props;
  }

  reload() {
    if (!this.state.isAdminInsurance) this.props.fetchData();
    else this.props.fetchData(this.props.userParty.InsuranceID);

    this.setState({ loading: true, showResults: false });
  }

  rerunEstimations(insuranceID, dateFrom, dateTo) {
    this.props.rerunEstimations(
      null,
      null,
      null,
      insuranceID,
      dateFrom,
      dateTo
    );
    this.setState({ loading: true });
  }

  deleteEstimation(estimationID) {
    var estimationArray = [];
    estimationArray.push(estimationID.toString());

    this.props.deleteEstimations(estimationArray);
    this.setState({ loading: true });
  }

  runEstimation(estimation, forceRun) {
    var estimationArray = [];
    estimationArray.push(
      Object.assign({}, estimation, {
        DateCreation: moment(estimation.DateCreation).toDate(),
        DateModification: moment(estimation.DateModification).toDate(),
        DateLastProcessing: moment(estimation.DateLastProcessing).toDate(),
      })
    );

    this.props.rerunSelectedEstimations(estimationArray, forceRun);
    this.setState({ loading: true });
  }

  deleteSelectedEstimations() {
    if (this.state.selectedRowsEstimationIDs) {
      this.props.deleteEstimations(this.state.selectedRowsEstimationIDs);
      this.setState({ loading: true });
    }
  }

  runSelectedEstimations(forceRun) {
    if (this.state.selectedRowsEstimations) {
      this.props.rerunSelectedEstimations(
        this.state.selectedRowsEstimations.map(estimation =>
          Object.assign({}, estimation, {
            DateCreation: moment(estimation.DateCreation).toDate(),
            DateModification: moment(estimation.DateModification).toDate(),
            DateLastProcessing: moment(estimation.DateLastProcessing).toDate(),
          })
        ),
        forceRun
      );
      this.setState({ loading: true });
    }
  }

  runFailedEstimations = insuranceID => {
    this.props.runFailedEstimations(insuranceID);
    this.setState({ loading: true });
  };

  runPendingEstimations = insuranceID => {
    this.props.runPendingEstimations(insuranceID);
    this.setState({ loading: true });
  };

  resetProcessingEstimations = insuranceID => {
    this.props.resetProcessingEstimations(insuranceID);
    this.setState({ loading: true });
  };

  updateEstimations = (dateFrom, dateTo, insuranceID) => {
    this.props.updateEstimations(dateFrom, dateTo, insuranceID);
  };

  chooseEstimationData = selectedTabKey => {
    const {
      newEstimationsData,
      pendingEstimationsData,
      failedEstimationsData,
      processingEstimationsData,
      smallDamageEstimationsData,
      partEstimationsData,
    } = this.state;

    if (!selectedTabKey || selectedTabKey === 'New') {
      return newEstimationsData;
    } else if (selectedTabKey === 'Failed') {
      return failedEstimationsData;
    } else if (selectedTabKey === 'Pending') {
      return pendingEstimationsData;
    } else if (selectedTabKey === 'Processing') {
      return processingEstimationsData;
    } else if (selectedTabKey === 'Smalldamage') {
      return smallDamageEstimationsData;
    } else if (selectedTabKey === 'Parts') {
      return partEstimationsData;
    }
  };

  chooseDashboardData = selectedTabKey => {
    const { dashboardData } = this.props;

    if (!selectedTabKey || selectedTabKey === 'New') {
      return dashboardData.GTEstimations;
    } else if (selectedTabKey === 'Failed') {
      return dashboardData.FailedEstimations;
    } else if (selectedTabKey === 'Pending') {
      return dashboardData.FailedEstimations;
    } else if (selectedTabKey === 'Processing') {
      return dashboardData.ProcessingEstimations;
    } else if (selectedTabKey === 'Smalldamage') {
      return dashboardData.SmallDamageEstimations;
    } else if (selectedTabKey === 'Parts') {
      return dashboardData.PartEstimations;
    }
  };

  tabChange = key => {
    const {
      newEstimationsData,
      pendingEstimationsData,
      failedEstimationsData,
      processingEstimationsData,
      smallDamageEstimationsData,
      partEstimationsData,
    } = this.state;

    if (key != 0 && this.api) this.api.deselectAll();

    this.clearSelectedEstimation();

    if (key === 'New') {
      this.setState({
        currentEstimationsData: newEstimationsData,
        selectedTabKey: key,
      });
      this.filterData(newEstimationsData);
    } else if (key === 'Failed') {
      this.setState({
        currentEstimationsData: failedEstimationsData,
        selectedTabKey: key,
      });
      this.filterData(failedEstimationsData);
    } else if (key === 'Pending') {
      this.setState({
        currentEstimationsData: pendingEstimationsData,
        selectedTabKey: key,
      });
      this.filterData(pendingEstimationsData);
    } else if (key === 'Processing') {
      this.setState({
        currentEstimationsData: processingEstimationsData,
        selectedTabKey: key,
      });
      this.filterData(processingEstimationsData);
    } else if (key === 'Smalldamage') {
      this.setState({
        currentEstimationsData: smallDamageEstimationsData,
        selectedTabKey: key,
      });
      this.filterData(smallDamageEstimationsData);
    } else if (key === 'Parts') {
      this.setState({
        currentEstimationsData: partEstimationsData,
        selectedTabKey: key,
      });
      this.filterData(partEstimationsData);
    }
  };

  tabMainChange = key => {
    const { selectedTabKey } = this.state;

    if (key === '1') {
      this.clearSelectedEstimation();

      this.setState({
        currentEstimationsData: this.chooseEstimationData(selectedTabKey),
      });
      this.filterData(this.chooseEstimationData(selectedTabKey));
    }
  };

  openUpdateEstimationsModal() {
    this.setState({ showUpdateEstimationsModal: true });
  }

  onFilterChange(value, name) {
    const { currentEstimationsData, filters } = this.state;

    let tempFilters = filters;
    let tempData = currentEstimationsData;

    if (value && value.toString().length > 0) {
      if (tempFilters.find(x => x.Name === name)) {
        _.remove(tempFilters, { Name: name });
      }

      tempFilters.push({ Name: name, Value: value });
      this.setState({ filters: tempFilters });
    } else {
      _.remove(tempFilters, { Name: name });
      this.setState({ filters: tempFilters });
    }

    if (tempData) {
      tempFilters.forEach(filter => {
        tempData = tempData.filter(x =>
          x[filter.Name]
            ? x[filter.Name]
                .toString()
                .toLowerCase()
                .indexOf(filter.Value.toString().toLowerCase()) > -1
            : x[filter.Name]
        );
      });

      this.setState({
        filteredData: tempData,
      });
    }
  }

  filterData = data => {
    const { filters } = this.state;

    let tempData = data;

    filters.forEach(filter => {
      tempData = tempData.filter(
        x =>
          x[filter.Name]
            .toString()
            .toLowerCase()
            .indexOf(filter.Value.toLowerCase()) > -1
      );
    });

    this.setState({
      filteredData: tempData,
    });
  };

  onClearFilter = title => {};

  onSelectChange = (selectedRowKeys, selectedRows) => {
    let rowsEstimationIDs = isArray(selectedRows)
      ? selectedRows.map(r => r.EstimationID)
      : [];

    this.setState({
      selectedRowKeys,
      selectedRowsTotal: selectedRows.length,
      selectedRowsEstimationIDs: rowsEstimationIDs,
      selectedRowsEstimations: isArray(selectedRows) ? selectedRows : [],
    });
  };

  getColumnWidth = (columns, addition) => {
    let width = (columns || []).reduce(
      (sum, columnDef) =>
        sum + (typeof columnDef.width === 'number' ? columnDef.width : 0),
      addition
    );
    return width;
  };

  render() {
    const counterClassName = 'col-md-3 col-sm-6 col-12';
    const {
      loading,
      selectedRowsEstimations,
      selectedRowsTotal,
      dateFrom,
      dateTo,
      insuranceID,
      error,
      selectedRowKeys,
      filteredData,
      newEstimationsData,
      processingEstimationsData,
      pendingEstimationsData,
      failedEstimationsData,
      smallDamageEstimationsData,
      partEstimationsData,
      isAdminInsurance,
    } = this.state;
    const { dashboardData, insurances, gtEstimationStatuses, user } =
      this.props;

    const rowSelection = {
      selectedRowKeys,
      onChange: (selectedRowKeys, rows) =>
        this.onSelectChange(selectedRowKeys, rows),
      fixed: true,
    };

    const columnsNew = createEstimationColumns(
      insurances,
      gtEstimationStatuses,
      this.runEstimation,
      this.deleteEstimation,
      false,
      true,
      false
    );

    const columnsFailed = createEstimationColumns(
      insurances,
      gtEstimationStatuses,
      this.runEstimation,
      this.deleteEstimation,
      true,
      true,
      false
    );

    const columnsPending = createEstimationColumns(
      insurances,
      gtEstimationStatuses,
      this.runEstimation,
      this.deleteEstimation,
      false,
      true,
      false
    );

    const columnsRunning = createEstimationColumns(
      insurances,
      gtEstimationStatuses,
      null,
      null,
      false,
      true,
      false
    );

    const columnsSmallDamage = createEstimationColumns(
      insurances,
      gtEstimationStatuses,
      this.runEstimation,
      this.deleteEstimation,
      false,
      true,
      false
    );

    const columnsParts = createEstimationColumns(
      insurances,
      gtEstimationStatuses,
      null,
      null,
      false,
      false,
      true
    );

    return (
      <div>
        <Tabs
          tabPosition="top"
          animated={true}
          size="small"
          onChange={this.tabMainChange}
          tabBarExtraContent={
            <Tooltip title="Refresh" placement="left">
              <button
                type="button"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                className={`btn btn-icon-only green btn-outline`}
                onClick={this.reload}
              >
                <i className={'fa fa-refresh'} />
              </button>
            </Tooltip>
          }
        >
          <Tabs.TabPane tab={`Διαχείριση`} key="0">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <h3
                className="page-title"
                style={{ margin: '10px 10px 15px 10px' }}
              >
                {I.t('LAST_RUN_DATE')}{' '}
                <small>
                  {dashboardData
                    ? moment(dashboardData.LastProcessingDate).format(
                        'DD-MM-YYYY'
                      )
                    : null}
                </small>
              </h3>
            </div>
            <div className="row form-group">
              <div className="col-md-4 row">
                <label
                  className="control-label col-md-4 col-sm-6 col-12"
                  style={{ marginTop: 5 }}
                >
                  {I.t('PERIOD')}
                </label>
                <RangePicker
                  className="col-md-8"
                  defaultValue={[
                    moment(moment(), dateFormat),
                    moment(moment(), dateFormat),
                  ]}
                  format={dateFormat}
                  onChange={this.onSelectPeriod}
                />
              </div>
              {!isAdminInsurance ? (
                <div className="col-md-4 row">
                  <label
                    className="control-label col-md-4 col-sm-6 col-12"
                    style={{ marginTop: 5 }}
                  >
                    {I.t('INSURANCE')}
                  </label>
                  {this.props.insurances ? (
                    <Dropdown
                      className="col-md-8"
                      inputClassName="flex-full-width"
                      value={this.state.insuranceID}
                      field={
                        new FieldInfo(
                          'insuranceID',
                          'Ασφαλιστική',
                          this.state.insuranceID,
                          this.props.insurances,
                          this.formContext,
                          ControlTypes.Dropdown
                        )
                      }
                    />
                  ) : null}
                </div>
              ) : null}
              <div className="col-md-1">
                <Tooltip title={I.t('ESTIMATIONS_UPDATE')}>
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    onClick={() =>
                      this.updateEstimations(dateFrom, dateTo, insuranceID)
                    }
                    disabled={
                      dashboardData ? dashboardData.TotalProcessing > 0 : false
                    }
                  >
                    Search
                  </Button>
                </Tooltip>
              </div>
            </div>
            <div className="row widget-row">
              <WidgetCounter
                containerClassName={counterClassName}
                colorClassName="blue"
                icon="bolt"
                title={I.t('NEW_FEMALE_PL_C')}
                subtitle={I.t('TOTAL_C')}
                value={dashboardData ? dashboardData.TotalNew : 0}
                actionIcon="info"
                // actionText={I.t('CONFIRM_RERUN_ESTIMATION')}
                action={this.openUpdateEstimationsModal}
                actionDisabled={false}
                loading={loading}
                tooltip={I.t('ESTIMATIONS_UPDATE')}
              />
              <WidgetCounter
                containerClassName={counterClassName}
                colorClassName="red"
                icon="ambulance"
                title={I.t('FAILED_FEM_C')}
                subtitle={I.t('TOTAL_C')}
                value={dashboardData ? dashboardData.TotalFailed : 0}
                actionText={I.t('CONFIRM_RUN_FAILED_ESTIMATION')}
                action={() =>
                  isAdminInsurance
                    ? this.runFailedEstimations(insuranceID)
                    : this.runFailedEstimations()
                }
                actionDisabled={
                  dashboardData ? dashboardData.TotalProcessing > 0 : false
                }
                loading={loading}
                tooltip={I.t('ESTIMATIONS_RUN')}
              />
              <WidgetCounter
                containerClassName={counterClassName}
                colorClassName="yellow"
                icon="clock-o"
                title={I.t('PENDING_C')}
                subtitle={I.t('TOTAL_C')}
                value={dashboardData ? dashboardData.TotalPending : 0}
                actionText={I.t('CONFIRM_RUN_PENDING_ESTIMATION')}
                action={() =>
                  isAdminInsurance
                    ? this.runPendingEstimations(insuranceID)
                    : this.runPendingEstimations()
                }
                actionDisabled={
                  dashboardData ? dashboardData.TotalProcessing > 0 : false
                }
                loading={loading}
                tooltip={I.t('ESTIMATIONS_RUN')}
              />
              <WidgetCounter
                containerClassName={counterClassName}
                colorClassName="white"
                icon={`cog font-blue ${
                  dashboardData && dashboardData.TotalProcessing > 0
                    ? 'fa-spin'
                    : ''
                }`}
                title={I.t('PROCESSING_C')}
                subtitle={I.t('TOTAL_C')}
                value={dashboardData ? dashboardData.TotalProcessing : 0}
                actionText={I.t('CONFIRM_RESET_PROCESSING_ESTIMATIONS')}
                action={() =>
                  isAdminInsurance
                    ? this.resetProcessingEstimations(insuranceID)
                    : this.resetProcessingEstimations()
                }
                actionIcon="warning"
                actionDisabled={
                  dashboardData && dashboardData.TotalProcessing === 0
                }
                loading={loading}
                tooltip={I.t('ESTIMATIONS_RESET')}
              />
            </div>
            <Spin spinning={loading} size="large" tip="Loading...">
              <Overview
                data={this.state.insurancesData}
                loading={this.props.submitting}
                insurances={insurances}
                error={error}
                totalEstimations={dashboardData && dashboardData.TotalNew}
                date={
                  dashboardData && dashboardData.LastProcessingDate
                    ? moment(dashboardData.LastProcessingDate).format(
                        'DD-MM-YYYY'
                      )
                    : ''
                }
              />
            </Spin>
          </Tabs.TabPane>
          <Tabs.TabPane tab={`${I.t('ESTIMATIONS')}`} key="1">
            <div
              className="grid-filters-wrap clearfix mb pt row"
              style={{ padding: 20 }}
            >
              <Col
                xxl={6}
                xl={8}
                lg={12}
                xs={24}
                style={{
                  display: 'flex',
                  marginBottom: 10,
                }}
              >
                <span className="gt-estimate-cell-span">ID</span>
                <Input
                  style={{
                    width: 200,
                  }}
                  onChange={e =>
                    this.onFilterChange(e.target.value, 'EstimationID')
                  }
                />
              </Col>
              <Col
                xxl={6}
                xl={8}
                lg={12}
                xs={24}
                style={{
                  display: 'flex',
                  marginBottom: 10,
                }}
              >
                <span className="gt-estimate-cell-span">Αρ.Κυκλοφορίας</span>
                <Input
                  style={{
                    width: 200,
                  }}
                  onChange={e =>
                    this.onFilterChange(e.target.value, 'RegistrationNumber')
                  }
                />
              </Col>
              <Col
                xxl={6}
                xl={8}
                lg={12}
                xs={24}
                style={{
                  display: 'flex',
                  marginBottom: 10,
                }}
              >
                <span className="gt-estimate-cell-span">Ασφαλιστική</span>
                <Select
                  allowClear={true}
                  showSearch
                  style={{ width: 200 }}
                  placeholder="Select an insurance"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={value => this.onFilterChange(value, 'InsuranceID')}
                >
                  {this.props.insurances &&
                    this.props.insurances.map(x => (
                      <Option value={x.ID}>{x.Description}</Option>
                    ))}
                </Select>
              </Col>
              <Col
                xxl={6}
                xl={8}
                lg={12}
                xs={24}
                style={{
                  display: 'flex',
                  marginBottom: 10,
                }}
              >
                <span className="gt-estimate-cell-span">User Ασφαλ.</span>
                <Input
                  style={{
                    width: 200,
                  }}
                  onChange={e =>
                    this.onFilterChange(e.target.value, 'UserName')
                  }
                />
              </Col>
              <Col
                xxl={6}
                xl={8}
                lg={12}
                xs={24}
                style={{
                  display: 'flex',
                  marginBottom: 10,
                }}
              >
                <span className="gt-estimate-cell-span">Μάρκα</span>
                <Input
                  style={{
                    width: 200,
                  }}
                  onChange={e => this.onFilterChange(e.target.value, 'Make')}
                />
              </Col>
              <Col
                xxl={6}
                xl={8}
                lg={12}
                xs={24}
                style={{
                  display: 'flex',
                  marginBottom: 10,
                }}
              >
                <span className="gt-estimate-cell-span">Μοντέλο</span>
                <Input
                  style={{
                    width: 200,
                  }}
                  onChange={e => this.onFilterChange(e.target.value, 'Model')}
                />
              </Col>
              <Col
                xxl={6}
                xl={8}
                lg={12}
                xs={24}
                style={{
                  display: 'flex',
                  marginBottom: 10,
                }}
              >
                <span className="gt-estimate-cell-span">Ημ.Δημιουργίας</span>
                <DatePicker
                  format="DD/MM/YY"
                  style={{
                    width: 200,
                  }}
                  onChange={(date, dateString) =>
                    this.onFilterChange(dateString, 'DateCreation')
                  }
                />
              </Col>
              <Col
                xxl={6}
                xl={8}
                lg={12}
                xs={24}
                style={{
                  display: 'flex',
                  marginBottom: 10,
                }}
              >
                <span className="gt-estimate-cell-span">Ημ.Τροποποίησης</span>
                <DatePicker
                  style={{
                    width: 200,
                  }}
                  onChange={(date, dateString) =>
                    this.onFilterChange(date, 'DateModification')
                  }
                />
              </Col>
            </div>
            <Tabs
              animated={true}
              tabPosition="top"
              size="small"
              onChange={this.tabChange}
            >
              <Tabs.TabPane
                tab={
                  <Badge
                    count={newEstimationsData ? newEstimationsData.length : 0}
                    style={{ backgroundColor: '#337AB7' }}
                  >
                    <span style={{ marginRight: 20 }}>
                      {I.t('NEW_FEMALE_PL_C')}
                    </span>
                  </Badge>
                }
                key="New"
              >
                <Spin spinning={loading} size="large" tip="Loading...">
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <span>
                          {I.t('ESTIMATIONS_CHOSEN')}:{' '}
                          <strong>{selectedRowsTotal}</strong>
                        </span>
                      </div>
                      {selectedRowsEstimations &&
                      selectedRowsEstimations.length > 0 ? (
                        <div className="col-6">
                          <Popconfirm
                            placement="bottom"
                            title={I.t('DELETE_SELECTED_CONFIRMATION_PL')}
                            onConfirm={this.deleteSelectedEstimations}
                            okText="Yes"
                            cancelText="No"
                          >
                            <button
                              type="button"
                              className="btn btn-danger float-right"
                            >
                              {I.t('DELETE')}
                            </button>
                          </Popconfirm>
                          <Popconfirm
                            placement="bottom"
                            title={I.t('RUN_SELECTED_CONFIRMATION_PL')}
                            onConfirm={() => this.runSelectedEstimations(false)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <button
                              type="button"
                              className="btn btn-info float-right"
                              style={{ marginRight: 10 }}
                            >
                              {I.t('RUN')}
                            </button>
                          </Popconfirm>
                        </div>
                      ) : null}
                    </div>
                    <Table
                      rowKey={x => x.ID}
                      rowSelection={rowSelection}
                      columns={columnsNew}
                      dataSource={filteredData || []}
                      scroll={{ x: this.getColumnWidth(columnsNew, 400) }}
                    />
                  </div>
                </Spin>
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={
                  <Badge
                    count={
                      failedEstimationsData ? failedEstimationsData.length : 0
                    }
                    style={{ backgroundColor: '#E7505A' }}
                  >
                    <span style={{ marginRight: 20 }}>
                      {I.t('FAILED_FEM_C')}
                    </span>
                  </Badge>
                }
                key="Failed"
              >
                <Spin spinning={loading} size="large" tip="Loading...">
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <span>
                          {I.t('ESTIMATIONS_CHOSEN')}:{' '}
                          <strong>{selectedRowsTotal}</strong>
                        </span>
                      </div>
                      {selectedRowsEstimations &&
                      selectedRowsEstimations.length > 0 ? (
                        <div className="col-6">
                          <Popconfirm
                            placement="bottom"
                            title={I.t('DELETE_SELECTED_CONFIRMATION_PL')}
                            onConfirm={this.deleteSelectedEstimations}
                            okText="Yes"
                            cancelText="No"
                          >
                            <button
                              type="button"
                              className="btn btn-danger float-right"
                            >
                              {I.t('DELETE')}
                            </button>
                          </Popconfirm>
                          <Popconfirm
                            placement="bottom"
                            title={I.t('RUN_SELECTED_CONFIRMATION_PL')}
                            onConfirm={() => this.runSelectedEstimations(false)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <button
                              type="button"
                              className="btn btn-info float-right"
                              style={{ marginRight: 10 }}
                            >
                              {I.t('RUN')}
                            </button>
                          </Popconfirm>
                        </div>
                      ) : null}
                    </div>
                    <Table
                      rowSelection={rowSelection}
                      columns={columnsFailed}
                      dataSource={filteredData || []}
                      scroll={{ x: this.getColumnWidth(columnsFailed, 400) }}
                    />
                  </div>
                </Spin>
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={
                  <Badge
                    count={
                      pendingEstimationsData ? pendingEstimationsData.length : 0
                    }
                    style={{ backgroundColor: '#F1C40F' }}
                  >
                    <span style={{ marginRight: 20 }}>{I.t('PENDING_C')}</span>
                  </Badge>
                }
                key="Pending"
              >
                <Spin spinning={loading} size="large" tip="Loading...">
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <span>
                          {I.t('ESTIMATIONS_CHOSEN')}:{' '}
                          <strong>{selectedRowsTotal}</strong>
                        </span>
                      </div>
                      {selectedRowsEstimations &&
                      selectedRowsEstimations.length > 0 ? (
                        <div className="col-6">
                          <Popconfirm
                            placement="bottom"
                            title={I.t('DELETE_SELECTED_CONFIRMATION_PL')}
                            onConfirm={this.deleteSelectedEstimations}
                            okText="Yes"
                            cancelText="No"
                          >
                            <button
                              type="button"
                              className="btn btn-danger float-right"
                            >
                              {I.t('DELETE')}
                            </button>
                          </Popconfirm>
                          <Popconfirm
                            placement="bottom"
                            title={I.t('RUN_SELECTED_CONFIRMATION_PL')}
                            onConfirm={() => this.runSelectedEstimations(false)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <button
                              type="button"
                              className="btn btn-info float-right"
                              style={{ marginRight: 10 }}
                            >
                              {I.t('RUN')}
                            </button>
                          </Popconfirm>
                        </div>
                      ) : null}
                    </div>
                    <Table
                      rowSelection={rowSelection}
                      columns={columnsPending}
                      dataSource={filteredData || []}
                      scroll={{ x: this.getColumnWidth(columnsPending, 300) }}
                    />
                  </div>
                </Spin>
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={
                  <Badge
                    count={
                      processingEstimationsData
                        ? processingEstimationsData.length
                        : 0
                    }
                    style={{ backgroundColor: 'gray' }}
                  >
                    <span style={{ marginRight: 20 }}>
                      {I.t('PROCESSING_C')}
                    </span>
                  </Badge>
                }
                key="Processing"
              >
                <Spin spinning={loading} size="large" tip="Loading...">
                  <Table
                    rowSelection={rowSelection}
                    columns={columnsRunning}
                    dataSource={filteredData || []}
                    scroll={{ x: this.getColumnWidth(columnsRunning, 300) }}
                  />
                </Spin>
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={
                  <Badge
                    count={
                      smallDamageEstimationsData
                        ? smallDamageEstimationsData.length
                        : 0
                    }
                    style={{ backgroundColor: '#36C6D3' }}
                  >
                    <span style={{ marginRight: 20 }}>
                      {I.t('SMALL_DAMAGE_C')}
                    </span>
                  </Badge>
                }
                key="Smalldamage"
              >
                <Spin spinning={loading} size="large" tip="Loading...">
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <span>
                          {I.t('ESTIMATIONS_CHOSEN')}:{' '}
                          <strong>{selectedRowsTotal}</strong>
                        </span>
                      </div>
                      {selectedRowsEstimations &&
                      selectedRowsEstimations.length > 0 ? (
                        <div className="col-6">
                          <Popconfirm
                            placement="bottom"
                            title={I.t('DELETE_SELECTED_CONFIRMATION_PL')}
                            onConfirm={this.deleteSelectedEstimations}
                            okText="Yes"
                            cancelText="No"
                          >
                            <button
                              type="button"
                              className="btn btn-danger float-right"
                            >
                              {I.t('DELETE')}
                            </button>
                          </Popconfirm>
                          <Popconfirm
                            placement="bottom"
                            title={I.t('RUN_SELECTED_CONFIRMATION_PL')}
                            onConfirm={() => this.runSelectedEstimations(true)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <button
                              type="button"
                              className="btn btn-info float-right"
                              style={{ marginRight: 10 }}
                            >
                              {I.t('RUN')}
                            </button>
                          </Popconfirm>
                        </div>
                      ) : null}
                    </div>
                    <Table
                      rowSelection={rowSelection}
                      columns={columnsSmallDamage}
                      dataSource={filteredData || []}
                      scroll={{
                        x: this.getColumnWidth(columnsSmallDamage, 350),
                      }}
                    />
                  </div>
                </Spin>
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={
                  <Badge
                    count={partEstimationsData ? partEstimationsData.length : 0}
                    style={{ backgroundColor: '#57af66' }}
                  >
                    <span style={{ marginRight: 20 }}>{I.t('PARTS_C')}</span>
                  </Badge>
                }
                key="Parts"
              >
                <Spin spinning={loading} size="large" tip="Loading...">
                  <div>
                    <Table
                      rowSelection={rowSelection}
                      columns={columnsParts}
                      dataSource={filteredData || []}
                      scroll={{
                        x: this.getColumnWidth(columnsParts, 350),
                      }}
                    />
                  </div>
                </Spin>
              </Tabs.TabPane>
            </Tabs>
          </Tabs.TabPane>
        </Tabs>

        <UpdateEstimationsResultsModal
          data={this.state.insurancesData}
          show={this.state.showUpdateEstimationsModal}
          onHide={() => this.setState({ showUpdateEstimationsModal: false })}
          loading={this.props.submitting}
          insurances={insurances}
          error={error}
          totalEstimations={dashboardData && dashboardData.TotalNew}
          date={
            dashboardData && dashboardData.LastProcessingDate
              ? moment(dashboardData.LastProcessingDate).format('DD-MM-YYYY')
              : ''
          }
        />
      </div>
    );
  }
}

export default GTEstimateDashboard;
